import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export const useCategoryListQuery = () => {
  return useQuery({
    queryKey: ["category-list"],
    queryFn: async () => {
      const res = await axios({
        method: "get",
        url: `${process.env.REACT_APP_API_URL}/category/getFeature`,
      });

      let response = res.data.data;

      return response;
    },
    refetchOnWindowFocus: false,
  });
};
